module.exports = __webpack_public_path__ + "img/consumer.5500180b.png";